import { render, staticRenderFns } from "./pay-complete.vue?vue&type=template&id=567bcd3e&scoped=true&"
import script from "./pay-complete.vue?vue&type=script&lang=js&"
export * from "./pay-complete.vue?vue&type=script&lang=js&"
import style0 from "./pay-complete.vue?vue&type=style&index=0&id=567bcd3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bcd3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567bcd3e')) {
      api.createRecord('567bcd3e', component.options)
    } else {
      api.reload('567bcd3e', component.options)
    }
    module.hot.accept("./pay-complete.vue?vue&type=template&id=567bcd3e&scoped=true&", function () {
      api.rerender('567bcd3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/management/collection/pay-complete.vue"
export default component.exports